// DS: C25A
import React, { useContext } from 'react';
import FolderDropdownDesktop from './FolderDropdownDesktop';
import FolderDropdownMobileV3 from './FolderDropdownMobileV3';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import { Props } from './types';

const FolderDropdown: React.FC<Props> = props => {
  const isMobile = useContext(MobileContext);

  if (isMobile) {
    return <FolderDropdownMobileV3 {...props} />;
  }
  return <FolderDropdownDesktop {...props} />;
};

export default FolderDropdown;
